import styled from "@emotion/styled";
import { Pagination } from "@mui/material";
import { format } from "date-fns";
import { useState } from "react";
import useGetContactRecords from "../../hooks/useGetContactRecords";
import theme from "../../theme";
import SubHeader from "./subHeader";
import { SortArrow } from "../sortArrow";
import Spinner from "../spinner";
import {
  formatDate,
  handleClickForSort,
  maskContactNumber,
  textSubstring,
} from "../../utils/util";
import { CustomTooltip } from "../common/CustomTooltip";
import { ModalLayout } from "../common/ModalLayout";
import { useWindowSize } from "@reactuses/core";
import { MobileContactRecord } from "./mobileContactRecord";
import { useI18n } from "../../locales";

export interface ClickBtnParams {
  fakeStart: Date | null;
  fakeEnd: Date | null;
  input: string;
}

const { md } = theme.screen;

const ContactRecordModal: React.FC<{
  open: boolean;
  onPressNo: () => void;
  area: string;
  id: string;
  idx: number;
}> = (props) => {
  const { open, onPressNo, area, id, idx } = props;
  const { width } = useWindowSize();
  const { t } = useI18n();
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState(0);
  const [sort, setSort] = useState<string | undefined>("");

  const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
    setPage(value - 1);
  };

  const onClickBtn = ({ fakeStart, fakeEnd, input }: ClickBtnParams) => {
    setStartDate(fakeStart);
    setEndDate(fakeEnd);
    setSearchKey(input);
  };
  const { data, isLoading } = useGetContactRecords({
    startDate: format(new Date(startDate as Date), "yyyy-MM-dd"),
    endDate: format(new Date(endDate as Date), "yyyy-MM-dd"),
    searchKey,
    area,
    page,
    admin_idx: idx.toString(),
    fetch: open,
    sort,
    limit: 10,
  });

  return (
    <ModalLayout
      open={open}
      onClose={() => {
        onPressNo();
        setSearchKey("");
        setEndDate(new Date());
        setStartDate(new Date());
        setSort("");
      }}
      width={"1058px"}
      // contentsOverflow="visible"
      fullScreen={width <= md ? true : false}
      pt="50px"
      pb={width <= md ? "0px" : undefined}
      backgroundColor={width <= md ? theme.color.neutral_50 : undefined}
    >
      <Header>
        <Title>{t.manageUser.viewContactRecord} /</Title>
        <User>{`${area} (${id})`}</User>
      </Header>

      {width > md && <SubHeader onClickBtn={onClickBtn} />}
      <Body>
        {width <= md && (
          <MobileContactRecord
            data={data}
            isLoading={isLoading}
            sort={sort}
            setSort={setSort}
            onClickBtn={onClickBtn}
          />
        )}
        {width > md && (
          <>
            <BodyHeader>
              {t.manageUser.recordsFound} - {data?.total_items ?? 0}{t.history?.casesUnit ?? ''}
            </BodyHeader>
            <TableHeader>
              {/* <TableHeaderList
                onClick={() => {
                  handleClickForSort("mobility_name", setSort);
                }}
                width={115}
                disabled={data?.list.length === 0}
              >
                기기 명 <SortArrow id="mobility_name" state={sort} />
              </TableHeaderList> */}
              {/* <TableHeaderList
                onClick={() => {
                  handleClickForSort("device_pid", setSort);
                }}
                width={130}
                disabled={data?.list.length === 0}
              >
                시리얼번호 <SortArrow id="device_pid" state={sort} />
              </TableHeaderList> */}

              <TableHeaderList
                onClick={() => {
                  handleClickForSort("owner", setSort);
                }}
                width={165}
                disabled={data?.list.length === 0}
              >
                {t.manageUser.userName} <SortArrow id="owner" state={sort} />
              </TableHeaderList>

              <TableHeaderList
                onClick={() => {
                  handleClickForSort("reading_phone", setSort);
                }}
                width={165}
                disabled={data?.list.length === 0}
              >
                {t.manageUser.contact} <SortArrow id="reading_phone" state={sort} />
              </TableHeaderList>

              <TableHeaderList
                onClick={() => {
                  handleClickForSort("who", setSort);
                }}
                width={140}
                disabled={data?.list.length === 0}
              >
                {t.manageUser.category} <SortArrow id="who" state={sort} />
              </TableHeaderList>
              <TableHeaderList
                onClick={() => {
                  handleClickForSort("reader_date", setSort);
                }}
                width={140}
                disabled={data?.list.length === 0}
              >
                {t.manageUser.contactViewTime}{" "}
                <SortArrow id="reader_date" state={sort} />
              </TableHeaderList>
              <TableHeaderList
                onClick={() => {
                  handleClickForSort("reader_name", setSort);
                }}
                width={140}
                disabled={data?.list.length === 0}
              >
                {t.manageUser.reader} <SortArrow id="reader_name" state={sort} />
              </TableHeaderList>
            </TableHeader>
            <TableBody>
              {isLoading && <Spinner />}
              {!isLoading && data && data.list.length === 0 && (
                <NoDataMassage>{t.manageUser.noDataFound}</NoDataMassage>
              )}
              {data &&
                data.list.map((el, idx) => (
                  <TableList key={idx.toString()}>
                    {/* 기기명 */}
                    {/* <CustomTooltip
                      title={el?.mobility_name}
                      active={el?.mobility_name?.length > 6}
                    >
                      <MobInfo
                        style={{
                          textAlign: "center",
                          minWidth: "115px",
                        }}
                      >
                        {textSubstring(el.mobility_name, 0, 6)}
                      </MobInfo>
                    </CustomTooltip> */}

                    {/* 시리얼 번호 */}
                    {/* <MobInfo
                      style={{
                        minWidth: "130px",
                        textAlign: "center",
                      }}
                    >
                      {el.device_pid}
                    </MobInfo> */}

                    {/* 이름 */}
                    <CustomTooltip
                      title={el?.owner}
                      active={el?.owner?.length > 8}
                    >
                      <MobInfo
                        style={{
                          minWidth: "165px",
                          textAlign: "center",
                        }}
                      >
                        {textSubstring(el.owner, 0, 8)}
                      </MobInfo>
                    </CustomTooltip>

                    {/* 연락처 */}

                    <MobInfo
                      style={{
                        minWidth: "165px",
                        textAlign: "center",
                      }}
                    >
                      {maskContactNumber(el.reading_phone)}
                      {/* {textSubstring(el.owner, 0, 8)} */}
                    </MobInfo>

                    {/* 구분 */}
                    <MobInfo
                      style={{
                        minWidth: "140px",
                        display: "flex",
                        textAlign: "center",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {el.who}
                    </MobInfo>

                    {/* 연락처 조회 일시 */}
                    <MobInfo
                      style={{
                        minWidth: "140px",
                        textAlign: "center",
                      }}
                    >
                      {formatDate(el.reader_date, "yyyy-MM-dd HH:mm")}
                    </MobInfo>

                    {/* 열람자 */}
                    <CustomTooltip
                      title={el?.reader_name}
                      active={el?.reader_name?.length > 8}
                    >
                      <MobInfo
                        style={{
                          minWidth: "140px",
                          textAlign: "center",
                        }}
                      >
                        {textSubstring(el.reader_name, 0, 8)}
                      </MobInfo>
                    </CustomTooltip>
                  </TableList>
                ))}
            </TableBody>
          </>
        )}
        {!isLoading && data?.list.length !== 0 && (
          <Footer>
            <Pagination
              count={data?.total_page}
              page={page + 1}
              siblingCount={width <= md ? 1 : 3}
              size={width <= md ? "small" : "medium"}
              onChange={handleChange}
            />
          </Footer>
        )}
      </Body>
    </ModalLayout>
  );
};
const Body = styled.div`
  background: ${theme.color.neutral_50};
  border-radius: 20px;
  width: 100%;
  height: 100%;
  min-height: 705px;
  min-width: 1005px;
  padding: 30px 30px 15px 30px;
  display: flex;
  flex-direction: column;

  @media (max-width: ${md}px) {
    padding: 8px 16px 0px 16px;
    border-radius: 0px;
    box-shadow: none;
    height: calc(100% - 26px);
    min-height: auto;
    min-width: auto;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  @media (max-width: ${md}px) {
    margin-bottom: 0px;
    padding: 8px 16px 0px 16px;
  }
`;

const Title = styled.p`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_500};
  margin-right: 5px;

  @media (max-width: ${md}px) {
    font-size: ${theme.fontSize.FONT_1};
    font-weight: ${theme.fontWeight.BOLD};
    color: ${theme.color.neutral_600};
  }
`;

const User = styled.p`
  font-weight: 500;
  font-size: 15px;
  line-height: 17px;
  color: ${theme.color.neutral_500};

  @media (max-width: ${md}px) {
    font-size: ${theme.fontSize.FONT_1};
    font-weight: ${theme.fontWeight.BOLD};
    color: ${theme.color.neutral_600};
  }
`;

const BodyHeader = styled.h1`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_600};
  padding-bottom: 15px;
  border-bottom: 3px solid ${theme.color.neutral_200};
`;

const TableHeader = styled.div`
  margin-top: 15px;
  margin-bottom: 10px;
  display: flex;
  gap: 15px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
`;

const TableHeaderList = styled.button<{ width: number }>`
  min-width: ${({ width }) => `${width}px`};
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: ${theme.color.neutral_500};
  cursor: pointer;
  transition: 200ms;
  &:hover {
    font-weight: bold;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background-color: transparent;
`;

const TableBody = styled.div`
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TableList = styled.div`
  background: ${theme.color.white};
  border-radius: 10px;
  width: 100%;
  height: 46px;
  display: flex;
  gap: 15px;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
`;

const Footer = styled.footer`
  display: flex;
  justify-content: center;
  margin-top: 15px;

  @media (max-width: ${md}px) {
    height: 56px;
    margin-top: 0px;
    align-items: center;

    nav {
      padding: 14px 0px;
    }

    button {
      min-width: 28px;
      height: 28px;
      font-size: ${theme.fontSize.FONT_1};
      font-weight: ${theme.fontWeight.SEMI_BOLD};
      color: ${theme.color.neutral_500};
    }
  }
`;

const MobInfo = styled.span`
  display: block;
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: ${theme.color.neutral_600};
  text-align: center;
`;
const NoDataMassage = styled.div`
  text-align: center;
  padding: 100px;
  color: ${theme.color.neutral_500};
`;

export default ContactRecordModal;
